/**
 * appLoader
 *
 * Thin wrapper around the pre-React splash element declared in index.html
 * (#app-loader). We expose imperative show/hide so the React tree can reuse
 * that single DOM node for chunk-reload recovery instead of shipping a
 * second, visually identical React loader component.
 *
 * The inline script in index.html attaches `window.__rrLoader` with
 * { show, hide }. This module is a safe SSR/typed wrapper around it.
 */

type LoaderApi = {
  show: () => void;
  hide: () => void;
};

function api(): LoaderApi | null {
  if (typeof window === "undefined") return null;
  return (window as unknown as { __rrLoader?: LoaderApi }).__rrLoader ?? null;
}

export function showAppLoader(): void {
  api()?.show();
}

export function hideAppLoader(): void {
  api()?.hide();
}

/**
 * Fires once the app is ready to display real content. The inline script in
 * index.html listens for this and fades the splash out. If the app never
 * fires it, the inline script falls back to a 1500ms watchdog so users
 * are never stuck on the splash.
 */
export function signalAppReady(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event("rr:app-ready"));
}
